/**
 * @file storage.js
 * @description localStorage 统一封装；禁止业务代码直接 localStorage.setItem
 * @module shared/utils/storage
 */

/** localStorage 中用户信息的键名（与存量约定一致） */
export const USER_STORAGE_KEY = 'user'

/**
 * 读取 localStorage JSON
 * @param {string} key
 * @returns {unknown|null} 解析失败或不存在时返回 null
 */
export function getStorageJson(key) {
  try {
    const raw = localStorage.getItem(key)
    if (raw == null || raw === '') return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

/**
 * 写入 localStorage JSON
 * @param {string} key
 * @param {unknown} value
 */
export function setStorageJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

/**
 * 删除 localStorage 项
 * @param {string} key
 */
export function removeStorageItem(key) {
  localStorage.removeItem(key)
}

/**
 * 读取当前登录用户缓存（localStorage user 对象）
 * @returns {Record<string, unknown>|null}
 */
export function getStoredUser() {
  const data = getStorageJson(USER_STORAGE_KEY)
  return data && typeof data === 'object' ? data : null
}

/**
 * 写入登录用户缓存
 * @param {Record<string, unknown>} user
 */
export function setStoredUser(user) {
  setStorageJson(USER_STORAGE_KEY, user)
}

/**
 * 清除登录用户缓存
 */
export function clearStoredUser() {
  removeStorageItem(USER_STORAGE_KEY)
}
